module.exports = __webpack_public_path__ + "static/media/silver_oak.4d92af5e.jpg";